import { pluralize } from '@/utils/strings'

export const strings = {
	methods : {
		makePlural (string, count) {
			return pluralize(string, count)
		},
	},
}
